import getTransaccionesPaymentHistoryClient from './getTransaccionesPaymentHistoryClient'

export const getTransaccionesPaymentHistoryClientPromise = getTransaccionesPaymentHistoryClient
